import { forwardRef } from "react";
import { FormHint } from "swash/form/FormHint";

export const FieldHint = forwardRef(({ state, ...props }, ref) => {
  return <FormHint data-field-hint ref={ref} {...props} />;
});
